var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositiveLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 25,
    viewBox: "0 0 74 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_3265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6786 11.6658H22.5545L20.5557 16.2348H19.3203L26.5563 0H27.7015L34.9375 16.2305H33.7021L31.6786 11.6616V11.6658ZM31.2518 10.6665L27.1186 1.29997L23.006 10.6665H31.2559H31.2518ZM36.4439 0H37.589V16.2305H36.4439V0ZM51.4578 11.6658H42.3337L40.3348 16.2348H39.0994L46.3355 0H47.4806L54.7167 16.2305H53.4812L51.4578 11.6616V11.6658ZM51.0309 10.6665L46.8978 1.29997L42.7852 10.6665H51.035H51.0309ZM6.14513 0H5V16.2305H6.14513V0ZM16.6647 0V7.59655H9.25216V8.63821H16.6647V16.2348H17.8099V0H16.6647ZM7.71301 7.38482C7.31899 7.38482 7.00295 7.71087 7.00295 8.11738C7.00295 8.52388 7.31899 8.84993 7.71301 8.84993C8.10704 8.84993 8.42307 8.52388 8.42307 8.11738C8.42307 7.71087 8.10704 7.38482 7.71301 7.38482ZM67.8508 16.2348H68.9959V0H67.8508V16.2305V16.2348ZM57.3312 16.2348V8.63821H64.7478V7.59655H57.3312V0H56.1861V16.2305H57.3312V16.2348ZM66.2829 8.84993C66.6769 8.84993 66.993 8.52388 66.993 8.11738C66.993 7.71087 66.6769 7.38482 66.2829 7.38482C65.8889 7.38482 65.5728 7.71087 65.5728 8.11738C65.5728 8.52388 65.8889 8.84993 66.2829 8.84993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1473 19.6265V19.8679H43.5439V20.575H44.1473V23.6069H45.001V20.575H45.9779V19.8679H44.9723V19.6434C44.9723 19.2412 45.157 19.0379 45.5141 19.0379C45.6905 19.0379 45.8547 19.1014 45.9861 19.1946L46.2241 18.5298C46.0312 18.3901 45.7439 18.3265 45.4525 18.3265C44.6029 18.3265 44.1473 18.8431 44.1473 19.6307V19.6265Z",
    fill: "url(#paint0_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.123 18.1614C46.807 18.1614 46.5771 18.3943 46.5771 18.6907C46.5771 18.9871 46.8111 19.22 47.123 19.22C47.435 19.22 47.6689 18.9786 47.6689 18.6695C47.6689 18.3816 47.435 18.1614 47.123 18.1614Z",
    fill: "url(#paint1_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5461 19.8383H46.6924V23.6027H47.5461V19.8383Z",
    fill: "url(#paint2_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1288 19.8383L49.959 22.633L48.8221 19.8383H47.9355L49.4993 23.6069H50.3818L51.9497 19.8383H51.1288Z",
    fill: "url(#paint3_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8294 19.7959C52.7418 19.7959 51.9414 20.6004 51.9414 21.7226C51.9414 22.8447 52.7336 23.6535 53.9567 23.6535C54.5846 23.6535 55.0977 23.4417 55.426 23.0395L54.9664 22.4975C54.7078 22.7727 54.3835 22.9082 53.9731 22.9082C53.3369 22.9082 52.8936 22.5567 52.791 22.0063H55.6559C55.6641 21.9216 55.6682 21.8157 55.6682 21.7437C55.6682 20.5666 54.8884 19.7959 53.8212 19.7959H53.8294ZM52.791 21.4177C52.8731 20.8672 53.2753 20.4988 53.8294 20.4988C54.3835 20.4988 54.794 20.8714 54.8637 21.4177H52.791Z",
    fill: "url(#paint4_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0764 18.373H56.2227V23.6068H57.0764V18.373Z",
    fill: "url(#paint5_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.317 19.7959C58.73 19.7959 58.1636 19.9526 57.7737 20.2617L58.1103 20.9053C58.3853 20.6724 58.808 20.5327 59.2185 20.5327C59.8259 20.5327 60.1296 20.8376 60.1296 21.3499V21.405H59.1856C58.0774 21.405 57.667 21.9004 57.667 22.5271C57.667 23.1538 58.1924 23.6535 59.0255 23.6535C59.5714 23.6535 59.9696 23.4714 60.1748 23.1453V23.6026H60.9833V21.3965C60.9833 20.3083 60.3759 19.7959 59.3211 19.7959H59.317ZM60.1255 22.4255C59.9819 22.815 59.6207 23.0098 59.202 23.0098C58.7629 23.0098 58.5043 22.8066 58.5043 22.489C58.5043 22.2138 58.6603 21.9893 59.2431 21.9893H60.1255V22.4255Z",
    fill: "url(#paint6_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6846 19.7959C63.2208 19.7959 62.8104 19.9568 62.5149 20.2956V18.3689H61.6611V23.6026H62.4738V23.1157C62.7611 23.4756 63.1839 23.6534 63.6846 23.6534C64.7517 23.6534 65.5357 22.8913 65.5357 21.7226C65.5357 20.5539 64.7476 19.7959 63.6846 19.7959ZM63.5902 22.8997C62.9745 22.8997 62.5025 22.4424 62.5025 21.7226C62.5025 21.0027 62.9745 20.5454 63.5902 20.5454C64.2059 20.5454 64.6697 21.0027 64.6697 21.7226C64.6697 22.4424 64.2059 22.8997 63.5902 22.8997Z",
    fill: "url(#paint7_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7426 20.9307C66.7426 20.6851 66.9889 20.5073 67.5102 20.5073C67.859 20.5073 68.2079 20.5793 68.5568 20.791L68.8851 20.1219C68.5568 19.9187 68.0027 19.7959 67.5184 19.7959C66.5333 19.7959 65.9136 20.2617 65.9136 20.9731C65.9136 22.4763 68.171 21.7988 68.171 22.5186C68.171 22.7812 67.9452 22.9336 67.4035 22.9336C66.9438 22.9336 66.4512 22.7769 66.1311 22.561L65.8027 23.23C66.1311 23.4714 66.7385 23.6535 67.346 23.6535C68.3721 23.6535 69.0001 23.1961 69.0001 22.489C69.0001 21.0154 66.7426 21.6929 66.7426 20.9307Z",
    fill: "url(#paint8_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2588 19.8297C35.7991 19.8297 35.3928 19.9906 35.1014 20.3252V18.4197H34.2559V23.5984H35.0603V23.1156C35.3435 23.4713 35.7622 23.6449 36.2588 23.6449C37.3136 23.6449 38.0935 22.8912 38.0935 21.731C38.0935 20.5708 37.3136 19.8255 36.2588 19.8255V19.8297ZM36.1644 22.8997C35.557 22.8997 35.0891 22.4466 35.0891 21.7352C35.0891 21.0238 35.557 20.5708 36.1644 20.5708C36.7719 20.5708 37.2316 21.0238 37.2316 21.7352C37.2316 22.4466 36.7719 22.8997 36.1644 22.8997Z",
    fill: "url(#paint9_linear_5_3265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0886 22.6287L38.9516 19.8721H38.0733L39.6494 23.6111L39.5878 23.7593C39.4236 24.1277 39.2513 24.2759 38.9516 24.2759C38.7218 24.2759 38.4919 24.1785 38.3278 24.0176L37.9912 24.6612C38.2211 24.8772 38.5987 25.0042 38.9599 25.0042C39.5632 25.0042 40.0229 24.7459 40.3553 23.9032L42.0464 19.8763H41.2337L40.0886 22.6329V22.6287Z",
    fill: "url(#paint10_linear_5_3265)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_3265",
    x1: 34.5471,
    y1: 19.4825,
    x2: 68.4678,
    y2: 24.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_3265",
    x1: 34.8878,
    y1: 16.9376,
    x2: 68.8084,
    y2: 21.5021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_3265",
    x1: 34.49,
    y1: 19.9102,
    x2: 68.4066,
    y2: 24.4787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_3265",
    x1: 34.5552,
    y1: 19.4063,
    x2: 68.4758,
    y2: 23.9708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_3265",
    x1: 34.6167,
    y1: 18.966,
    x2: 68.5374,
    y2: 23.5344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_3265",
    x1: 34.7649,
    y1: 17.8522,
    x2: 68.6855,
    y2: 22.4206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_3265",
    x1: 34.7152,
    y1: 18.2165,
    x2: 68.6359,
    y2: 22.7849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_3265",
    x1: 34.8676,
    y1: 17.0859,
    x2: 68.7883,
    y2: 21.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_3265",
    x1: 34.872,
    y1: 17.0605,
    x2: 68.7926,
    y2: 21.6289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_3265",
    x1: 34.3462,
    y1: 20.9603,
    x2: 68.2669,
    y2: 25.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_3265",
    x1: 34.2685,
    y1: 21.5489,
    x2: 68.1892,
    y2: 26.1173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36A9A2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_3265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 25,
    fill: "white",
    transform: "translate(5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveLogo);
export default __webpack_public_path__ + "static/media/positiveLogo.35865366712645608b4f306297470e91.svg";
export { ForwardRef as ReactComponent };